import { withInstall } from '../utils/index';
import './index.less';
import BaseMap from './index.vue';

export const TlbsBaseMap = withInstall(BaseMap);
export default TlbsBaseMap;
